import { Application } from '@hotwired/stimulus';

const application = Application.start();
window.stimulusApp = application;

// Configure Stimulus development experience
application.debug = false;

export { application };
